const Config = {
	// menu options for drop down menu
	menuOptions: [
		{
			name: "save",
			label: "Save Template",
			icon: {
				type: "fa5",
				name: "floppy-disk",
			},
		},
		{
			name: "addForm",
			label: "Add Form",
			icon: {
				type: "fa5",
				name: "circle-plus",
			},
		},
		{
			name: "addEasyAddForm",
			label: "Add 360 Form",
			icon: {
				type: "fa5",
				name: "user-plus",
			},
		},
		{
			name: "addExternalForm",
			label: "Add External Form",
			icon: {
				type: "fa5",
				name: "arrow-up-right-from-square",
			},
		},
		{
			name: "delete",
			label: "Delete Template",
			icon: {
				type: "fa5",
				name: "trash-can",
			},
		},
	],
	// when creating a new form, these are the initial default form values
	createFormValues: {
		basicForms: {
			type: "basic",
			form: null,
			assignment: {
				authors: [],
				signers: [],
				redacted: false,
				daysToCompleteAuthors: 30,
				daysToCompleteSigners: 30,
				visibleToSubject: false,
			},
			isEditing: true,
			editableForm: null,
			dateType: "relative",
			unsaved: true,
			isNewForm: true,
		},
		externalForms: {
			type: "external",
			form: null,
			assignment: {
				authorName: "",
				authorEmail: "",
				emailMessage: "",
				visibleToSubject: false,
				redacted: false,
			},
			isEditing: true,
			editableForm: null,
			unsaved: true,
			isNewForm: true,
		},
		easyAddForms: {
			formID: null,
			formObject: null,
			who_can_add_form: {
				any_employee: true,
				subject: false,
				manager_or_chain_of_command: false,
				admin_or_group_admin: false,
			},
			subject_employee_choose_author: "",
			who_signs_off: [],
			author_due_date: 0,
			signer_due_date: 1,
			due_date_types: "relative",
			redact: false,
			visibility: false,
			allow_comments: false,
			is_active: true,
			requiresApproval: null,
			unsaved: true,
			editableForm: null,
			isEditing: true,
			isNewForm: true,
		},
	},
};

export default Config;
